import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import XIcon from "Images/quiz/x.svg";
import restartIcon from "Images/quiz/restart.svg";
import LeftArrow from "Images/quiz/arrowLeft.svg";
import Logo from "Images/quiz/logo_square.svg";
import { CSSTransition } from "react-transition-group";
import futureQuizLogo from "Images/quiz/future_quiz_logo.svg";
import futureQuizLogoMob from "Images/quiz/future_quiz_logo_mob.svg";
import styles from "./style.module.css";
import { useHistory } from "react-router";
const QuizHeader = ({ onClose, goBack, showHeader, isFirstQuestion, isFuture }) => {
    const isHyrox = window.location.pathname.includes("hyrox");
    const history = useHistory();
    const restartHyrox = () => {
        localStorage.removeItem("hyroxResults");
        history.push("/quiz-new/hyrox/");
        window.location.reload();
    };
    return (_jsx(CSSTransition, { in: showHeader, timeout: 200, classNames: {
            enterActive: styles.MyClassEnterActive,
            enterDone: styles.MyClassEnterDone,
            exitActive: styles.MyClassExit,
            exitDone: styles.MyClassExitActive,
        }, children: _jsx("div", { className: `${styles.quiz_header}`, children: _jsxs("div", { className: styles.quiz_header_wrapper, children: [_jsx("button", { type: "button", className: `${styles.header_button} ${isFirstQuestion ? styles.hidden : ""}`, onClick: goBack, children: _jsx("img", { src: LeftArrow, alt: "" }) }), isFuture ? (_jsxs(_Fragment, { children: [_jsx("img", { className: styles.logoWrapper, alt: "logo", src: futureQuizLogo }), _jsx("div", { className: styles.logoWrapperMob, children: _jsx("img", { src: futureQuizLogoMob, alt: "" }) })] })) : (_jsx("img", { src: Logo, className: styles.gainful_logo, alt: "logo" })), isHyrox && !isFirstQuestion ? (_jsx("button", { onClick: restartHyrox, type: "button", className: styles.header_button, children: _jsx("img", { src: restartIcon, className: styles.x_button, alt: "" }) })) : isHyrox ? (_jsx("div", {})) : (_jsx("button", { onClick: onClose, type: "button", className: styles.header_button, children: _jsx("img", { src: XIcon, className: styles.x_button, alt: "" }) }))] }) }) }));
};
export default memo(QuizHeader);
